// 用于展示顶层弹窗 消息通知
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteOutline } from 'antd-mobile-icons';
import _ from 'lodash';

import './index.less';
import {
  hide_global_popup,
  // show_global_popup
} from '@/actions';

const TopPopupForNotification = () => {
  const popupElementTop = useRef(null);
  const { globalPOPUPState, message = {} } = useSelector(state => state.notificationInfo);
  const [startY, setStartY] = useState(0);
  const [top, setTop] = useState(`-10%`);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const text = _.get(message, 'text', '');
  const type = _.get(message, 'type', '');
  const activityId = _.get(message, 'activityId', '');

  useEffect(() => {
    // EventEmitter.on('notification', (data) => {
    //   dispatch(show_global_popup());
    // })

    const timer = setTimeout(() => {
      dispatch(hide_global_popup());
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    console.log('globalPOPUPState', globalPOPUPState);
    if (popupElementTop.current) {
      if (globalPOPUPState) {
        popupElementTop.current.style.top = '1%';
      } else {
        popupElementTop.current.style.top = '-100%';
      }
    }
  }, [globalPOPUPState]);

  const handleFunc = () => {
    if (type === 'EVALUATION_REPORT_TO_STAFF') {
      navigate('/client/health-report');
    }
    if (type === 'STAFF_FORM_TASK_AI_REPORT') {
      navigate('/client/ai-report-transition');
    }
    if (type === 'ACTIVITY_REPORT_GENERATED') {
      if (activityId === 'inner_child') {
        navigate('/client/doll-reports', {replace: true});
        return;
      }
      if (activityId === 'inner_child_avatar') {
        navigate('/client/doll-reports-online', {replace: true});
        return;
      }
      // 默认活动做房树人流程处理
      navigate('/client/house-tree-person-reports', {replace: true});
    }
    if (type === 'WORK_ORDER_CREATED') {
      navigate('/therapist/home/work-order');
    }
    if (type === 'WORK_ORDER_REOPENED') {
      navigate('/therapist/home/work-order');
    }
    if (type === 'ACTIVITY_TEAM_REPORT_GENERATED') {
      navigate('/client/doll-group-report-online', {replace: true});
    }
    dispatch(hide_global_popup());
  }

  // 左滑取消消息通知
  const handleTouchStart = (e) => {
    e.stopPropagation();
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    const moveY = e.touches[0].clientY;
    const top = moveY - startY;
    console.log('moveY', moveY, startY, top);
    if (top < 0) {
      setTop(top);
      console.log('Math.abs(moveY - startY)', Math.abs(moveY - startY));
      if (Math.abs(moveY - startY) > 50) {
        dispatch(hide_global_popup());
        return;
      }
    }
  };

  return (
    <div
      id="top-popup-for-notification"
      ref={popupElementTop}
      style={{ top: top }}
      className={`top-popup-for-notification`}
      onClick={() => {
        handleFunc();
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <div className='top-popup-for-notification-content'>{text}</div>
      <div className='top-popup-for-notification-icon'>
        <DeleteOutline
          color='var(--adm-color-danger)'
          fontSize='24px'
          onClick={(event) => {
            event.stopPropagation(); // 阻止事件冒泡
            dispatch(hide_global_popup());
          }}
        />
      </div>
    </div>
  )
};

export default TopPopupForNotification;